import React, { useEffect, useState } from 'react'
import LeadInfo from './LeadInfo'
import LeadDetails from './LeadDetails'
import CompanyDetails from './CompanyDetails'
import { ToggleSwitch } from '../../../commons'
import { connect } from 'react-redux'
import { RootState } from '../../../../redux/rootReducers'
import { GetAllFinacUserPayloadType } from '../../../../commonTypes/authTypes'
import { getAllFinacUsersAction } from '../../../../redux/auth'
import { formateDateWithTime } from '../../../../utils/commonFunctions'
import useDebounce from '../../../../customHooks/useDebounce'
import { CompanyDetailsType, GetCityListPayloadType, LeadInfoDetailsType, SelectStageOptionType, StageDetailsType } from '../../../../commonTypes/clientDirectoryTypes'
import { SelctOptionType } from '../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm'
import { LoginResponseType } from '../../../../redux/auth/authTypes'
import { GetUsersDepartmentPayloadType } from '../../../../commonTypes/masterDataTypes'
import { getMasterDataScopeOfWorkAction } from '../../../../redux/masterData'
import { ScopeOfWorkListType } from '../../../../redux/masterData/masterTypes'
import ScopeOfWorkDetails from './ScopeOfWorkDetails'
import { PaperClipIcon } from '../../../Icon'
import MultiUploadWithApi from '../../../commons/UploadFileWithApi/MultiUploadWithApi'
import { multipleUploadFilesAction, resetMultipleFileUploadData, resetMultipleFileUploadError, resetMultipleFileUploadFetching, resetMultipleFileUploadSuccess} from '../../../../redux/clientSettings'
import { resetSasTokenForDownloadFile } from '../../../../redux/stcoTools'
import { StockUploadFilePayloadType } from '../../../../commonTypes/clientSettingsTypes'
import { MulitpleFileUploadData } from '../../../../redux/clientSettings/clientSettingTypes'
import MultiFilePreviewModal from "../../../commons/MultiPreviewWithApi/MultiFilePreviewModal"
import FileUploadErrorModal from '../../../commons/FileUploadErrorModal'
import { getStageListAction, resetLeadStageList } from '../../../../redux/clientDirectory'

type AppProps = {
  token: string | null;
  clientAadharUniqueCheckMessage: string | null;
  clientPanUniqueCheckMessage: string | null;
  leadInfoDetails: LeadInfoDetailsType;
  fetching: boolean;
  setLeadInfoDetails: (data: any) => void;
  finacUser: any;
  singleClientDirectory: any;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  handleClientDirectoryFormSubmit: () => void;
  handleGoBack: () => void;
  loginData: LoginResponseType;
  selectedAccessTeam: number[] | [];
  setSelectedAccessTeam: React.Dispatch<React.SetStateAction<number[]>>;
  setUserSelected: React.Dispatch<React.SetStateAction<SelctOptionType[]>>;
  userSelected: SelctOptionType[]
  modal:boolean;
  showUploadModal:()=>void;
  containerName:string|undefined;
  uploadSuccessArray:any;
  setUploadSuccessArray:any;
  uploadData:any;
  setUploadData:any;
  clientFileUploadSuccess: number|null;
  dispatchResetFileUploadSuccess:()=>void;
  dispatchResetFileUploadError:()=>void;
  clientDirectoryFileUploadData:MulitpleFileUploadData[]|[];
  dispatchUploadFilesAction:(data:StockUploadFilePayloadType)=>void;
  dispatchResetFileUploadData:()=>void;
  dispatchResetFileUploadFetching:()=>void;
  clientDirectoryFileUploadFetching:boolean;
  setShowImagePreview: React.Dispatch<React.SetStateAction<boolean>>
  scopeOfWork:SelctOptionType[];
  setScopeOfWork:React.Dispatch<React.SetStateAction<SelctOptionType[]>>;
  selectedScopeOfWork:number[] | [];
  setSelectedScopeOfWork:React.Dispatch<React.SetStateAction<number[]>>;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  scopeOfWorkTotalCount: number;
  dispatchGetMasterDataScopeOfWorkAction:(data:GetUsersDepartmentPayloadType)=>void;
  dispatchLeadStageData: (data:GetCityListPayloadType) => void;
  dispatchResetLeadStageData:()=>void;
  leadStageData:StageDetailsType[];
}
const LeadInfoTab = ({
  token,
  loginData,
  fetching,
  leadInfoDetails,
  setLeadInfoDetails,
  finacUser,
  clientAadharUniqueCheckMessage,
  clientPanUniqueCheckMessage,
  dispatchGetAllFinacUsersAction,
  handleClientDirectoryFormSubmit,
  handleGoBack,
  singleClientDirectory,
  selectedAccessTeam,
  setSelectedAccessTeam,
  setUserSelected,
  userSelected,
  modal,
  showUploadModal,
  containerName,
  uploadSuccessArray,
  setUploadSuccessArray,
  // handleUploadFile,
  uploadData,
  setUploadData,
  clientFileUploadSuccess,
  dispatchResetFileUploadSuccess,
  dispatchResetFileUploadError,
  dispatchUploadFilesAction,
  clientDirectoryFileUploadData,
  dispatchResetFileUploadData,
  dispatchResetFileUploadFetching,
  clientDirectoryFileUploadFetching,
  // setShowImagePreview,
  scopeOfWork,
  setScopeOfWork,
  selectedScopeOfWork,
  setSelectedScopeOfWork,
  scopeOfWorkList,
  scopeOfWorkTotalCount,
  dispatchGetMasterDataScopeOfWorkAction,
  leadStageData,
  dispatchLeadStageData,
  dispatchResetLeadStageData
}: AppProps) => {
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(50);
  const [offset, setoffset] = useState<number>(0);
  const [option, setOption] = useState([])
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [finalScopeOfWorkList , setFinalScopeOfWorkList] = useState<any>([])
  const [scopeOfWorkOffset , setScopeOfWorkOffset] = useState<number>(0)
  const [scopeOfWorkLimit , setScopeOfWorkLimit] = useState<number>(20)
  const [searchValue , setSearchValue] = useState("")
  const [scopeOfWorkText , setScopeOfWorkText] = useState("")
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [stageDropDown,setStageDropDown]=useState<SelectStageOptionType[] | []>([])

  const isEdit = false;
    useEffect(()=>{
      dispatchResetFileUploadFetching();
      dispatchResetFileUploadData();
      dispatchResetFileUploadSuccess();
      dispatchResetFileUploadError();
      dispatchResetLeadStageData()
      if(token){
      dispatchLeadStageData({token})
      }
    },[])
  useEffect(() => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: 'stco_users',
      status: 1,
      search_term: text,
    }
    dispatchGetAllFinacUsersAction(finalData)
  }, [])

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name} ${user?.last_name}`,
        image: user?.profile_pic?.file_url
      };
    })
    if (offset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser])

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: 'stco_users',
        status: 1,
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData)
      }
    }
  }, [offset])

  useEffect(()=>{
    if(token){
      let finalUserData = {
        token,
        limit:scopeOfWorkLimit,
        offset:scopeOfWorkOffset,
        searchValue: scopeOfWorkText,
        status:1
        };
        dispatchGetMasterDataScopeOfWorkAction(finalUserData)
    }


  },[])

  useEffect(() => {
    const finalScopeOfWorkData = scopeOfWorkList?.map((scope: any) => {
      
      return {
        value: scope?._id,
        label: scope?.scope_of_work_name,
      };
    })
    if (scopeOfWorkOffset > 0) {
      setFinalScopeOfWorkList([...finalScopeOfWorkList, ...finalScopeOfWorkData]);
    } else {
      setFinalScopeOfWorkList(finalScopeOfWorkData);
    }
  }, [scopeOfWorkList])
  useEffect(() => {
    if (token) {
      let finalUserData = {
      token,
      limit:scopeOfWorkLimit,
      offset:scopeOfWorkOffset,
      searchValue: scopeOfWorkText,
      status:1
      };
      if (scopeOfWorkOffset <= scopeOfWorkTotalCount) {
        dispatchGetMasterDataScopeOfWorkAction(finalUserData)
      }
    }
  }, [scopeOfWorkOffset])

   useEffect(()=>{
      if(leadStageData?.length>0){
        let finalData=leadStageData?.map((item:StageDetailsType)=>{
          return {
            label:item?.stage_name,
            value:item?._id,
            uniqueId:item?.unique_id
          }
        })
        setStageDropDown([...finalData])
      }
  
    },[leadStageData])
  
  const fetchNewCategoryData = (search: string) => {
    const finalData = {
      token,
      limit:scopeOfWorkLimit,
      offset:scopeOfWorkOffset,
      searchValue: scopeOfWorkText,
      status:1
    }
    dispatchGetMasterDataScopeOfWorkAction(finalData)
  }
  
  useDebounce(() => {
    if (scopeOfWorkText) {
      fetchNewCategoryData(scopeOfWorkText)
    }
    else {
      const finalData = {
        token,
        limit:scopeOfWorkLimit,
        offset:scopeOfWorkOffset,
        searchValue: scopeOfWorkText,
        status:1
      }
      dispatchGetMasterDataScopeOfWorkAction(finalData)
    }
  }, 500, [scopeOfWorkText]);


  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: 'stco_users',
      status: 1,
      search_term: text,
    }
    dispatchGetAllFinacUsersAction(finalData)
  }

  useDebounce(() => {
    if (text) {
      fetchNewData(text)
    }
    else {
      const finalData = {
        token,
        offset,
        limit,
        user_type: 'stco_users',
        status: 1,
        search_term: text,
      }
      dispatchGetAllFinacUsersAction(finalData)
    }
  }, 500, [text]);

  const handleToggleIsMaintenance = () => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        companyDetails: {
          ...prev.companyDetails,
          gstNumberRegister: !leadInfoDetails?.companyDetails?.gstNumberRegister
        }
      }
    })
  }

  const handleCompanyDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        companyDetails: {
          ...prev.companyDetails,
          [e.target.name]: e.target.value
        }
      }
    })
  }

  const handleLeadDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          [e.target.name]: e.target.value
        }
      }
    })
  }
  const handleLeadInfoDetailsChange = (e: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          [e.target.name]: e.target.value
        }
      }
    })
  }
  const handleLeadAssignedToChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          leadAssignedTo: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const handleDemoAssignedToChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          demoAssignedTo: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }

  const  handleMeetingAssignedToChange  = (data: any) => {
    setLeadInfoDetails((prev: any) => {
        return {
            ...prev,
            leadInfo: {
                ...prev.leadInfo,
                meetingAssignedTo: {
                    value: data?.value,
                    label: data?.label
                }
            }
        }
    })
    }


  const handleAccessMemberChange = (e: any) => {
    let accessTeamIdName: any = e?.map((e: any) => {
      return e?.value;
    });
    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setUserSelected(totalUser);
    setSelectedAccessTeam(accessTeamIdName);
  };

  const handleLeadReceivedOnChange = (date: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadInfo: {
          ...prev.leadInfo,
          leadReceivedOn: date === "Invalid date" ? null : date
        }
      }
    })
  }

  const handleScopeOfWorkChange = (e: any) => {
    let scopeOfWorkIdName: any = e?.map((e: any) => {
      return e?.value;
    });
    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setScopeOfWork(totalUser);
  
    setSelectedScopeOfWork(scopeOfWorkIdName);
  };

  const handleStageChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          stage: {
            value: data?.value,
            label: data?.label
          },
          uniqueId:data?.uniqueId
        }
      }
    })
  }
  const handleCallFrequencyChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          callFrequency: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const handleLeadCategaryChange = (data: any) => {
    setLeadInfoDetails((prev: any) => {
      return {
        ...prev,
        leadDetails: {
          ...prev.leadDetails,
          leadCategary: {
            value: data?.value,
            label: data?.label
          }
        }
      }
    })
  }
  const handleFileChange = (file: any) => {
    const finalData = {
      token,
      fileData: file,
      containerType:2,

    };
    return dispatchUploadFilesAction(finalData);
  }


  return (
    <div className='card'>
      <LeadInfo
        setoffset={setoffset}
        limit={limit}
        setText={setText}
        fetching={fetching}
        finalUserList={finalUserList}
        handleLeadInfoDetailsChange={handleLeadInfoDetailsChange}
        handleLeadAssignedToChange={handleLeadAssignedToChange}
        handleDemoAssignedToChange={handleDemoAssignedToChange}
        handleLeadReceivedOnChange={handleLeadReceivedOnChange}
        handleMeetingAssignedToChange={handleMeetingAssignedToChange}
        handleAccessMemberChange={handleAccessMemberChange}
        setLeadInfoDetails={setLeadInfoDetails}
        leadInfo={leadInfoDetails?.leadInfo}
        userSelected={userSelected}
        loginData={loginData}
        selectedAccessTeam={selectedAccessTeam}
        setSelectedAccessTeam={setSelectedAccessTeam}
        setUserSelected={setUserSelected}

      />
      <LeadDetails
        handleLeadDetailsChange={handleLeadDetailsChange}
        handleStageChange={handleStageChange}
        handleCallFrequencyChange={handleCallFrequencyChange}
        handleLeadCategaryChange={handleLeadCategaryChange}
        leadDetails={leadInfoDetails?.leadDetails}
        stageDropDown={stageDropDown}
      />
      <CompanyDetails
        handleCompanyDetailsChange={handleCompanyDetailsChange}
        companyDetails={leadInfoDetails?.companyDetails}


      />
      <ScopeOfWorkDetails
        scopeOfWork={scopeOfWork}
        handleScopeOfWorkChange={handleScopeOfWorkChange}
        finalScopeOfWorkList={finalScopeOfWorkList}
        setScopeOfWorkText={setScopeOfWorkText}
        setScopeOfWorkOffset={setScopeOfWorkOffset}
        scopeOfWorkLimit={scopeOfWorkLimit}
        fetching={fetching}
        loginData={loginData}
        modal={modal}
        showUploadModal={showUploadModal}
        containerName={containerName}
        uploadSuccessArray={uploadSuccessArray}
        setUploadSuccessArray={setUploadSuccessArray}
        // handleUploadFile={handleUploadFile}
        uploadData={uploadData}
        setShowImagePreview={setShowImagePreview}
     

      />
      <div style={{display:'flex'}}>
      
      <span className='mt-5'>Do you have registered GST Number?</span>
      <div className="mb-5 ml-3" style={{marginTop:'44px'}}>
        <ToggleSwitch
          handleToggleChange={handleToggleIsMaintenance}
          isChecked={leadInfoDetails?.companyDetails?.gstNumberRegister}
        />
      </div>
      <div className="col-md-4 mb-3  ml-5 d-flex p-0" style={{marginTop:'44px'}}>
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              className="btn btn-outline"
              onClick={() => {
                showUploadModal();
              }}
            >
              + Upload File
            </button>
            <div className="pointer position-relative ml-4">
              {uploadData?.length ? (
                <span id="Popover1" onClick={() => setShowImagePreview(true)}>
                  <PaperClipIcon />
                  <span className="badge count-badge" style={{ left: "11px" }}>
                    {uploadData?.length}
                  </span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
     
      </div>
        {modal && (
          <MultiUploadWithApi
            modal={modal}
            toggleModal={showUploadModal}
            token={token}
            handleFileChange={handleFileChange}
            isDraggableModal
            acceptedFiles={"image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"}
            maxFileSize={2000000}
            supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
            allFileData={uploadData}
            setAllFileData={setUploadData}
            multipleFileUploadSuccess={clientFileUploadSuccess}
            multipleFileUploadData={clientDirectoryFileUploadData}
            multipleFileUploadFetching={clientDirectoryFileUploadFetching}
            dispatchResetMultipleFileUploadError={dispatchResetFileUploadError}
            dispatchResetMultipleFileUploadSuccess={dispatchResetFileUploadSuccess}
          />
        )}

        {showImagePreview && (
          <MultiFilePreviewModal
           show={showImagePreview}
           files={uploadData}
           onClose={() => setShowImagePreview(false)}
           token={token}
           setAllFileData={setUploadData}
           type={"clientDirectory"}
           />
        )}
      </div>
      <hr></hr>
      <div className='row'>
        <div className='col-md-12 text-right'>
          <button className='btn' style={{ border: "1px solid #bfcbe1", marginRight: '15px' }}
            onClick={() => handleGoBack()}
          >Cancel</button>
          <button className='btn btn-primary'
            disabled={clientPanUniqueCheckMessage?.includes("PAN number already exists") || clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists")}
            onClick={handleClientDirectoryFormSubmit}
          >{singleClientDirectory ? "Save Changes" : "Save"}</button>
        </div>
      </div>
      <FileUploadErrorModal/>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  fetching: state.auth.fetching,
  loginData: state.auth.loginData,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,
  clientDirectoryFileUploadData: state.clientSettings.multipleFileUploadData,
  clientDirectoryFileUploadFetching: state.clientSettings.multipleFileUploadFetching,
  resetSasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  clientFileUploadSuccess: state.clientSettings.multipleFileUploadSuccess,
  leadStageData: state.clientDirectory.leadStageList
})
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),
  dispatchResetFileUploadSuccess: () => dispatch(resetMultipleFileUploadSuccess()),
  dispatchResetFileUploadError: () => dispatch(resetMultipleFileUploadError()),
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType)=> dispatch(multipleUploadFilesAction(data)),
  dispatchResetFileUploadData:()=>dispatch(resetMultipleFileUploadData()),
  dispatchResetFileUploadFetching:()=>dispatch(resetMultipleFileUploadFetching()),
  dispatchLeadStageData: (data:GetCityListPayloadType) => dispatch(getStageListAction(data)),
  dispatchResetLeadStageData:()=>dispatch(resetLeadStageList()),
})

export default connect(mapStateToProps, dispatchStateToProps)(LeadInfoTab)